import { useState } from "react";
import { AxiosError } from "axios";

import {
  AlertError,
  ModalSubProfileEdit,
  ModalSubProfileEditBody,
  ModalSubProfileEditFooter,
  ModalSubProfileEditHeader,
  TextAreaInput,
} from "~components";
import { translate } from "~utils";

type ModalContentSchoolFeedbackAdditionalInfoProps = {
  onAdditionalInfoSubmit: (info: string) => void;
  onDismiss: () => void;
  title: string;
  error?: AxiosError | null;
};

export function ModalContentSchoolFeedbackAdditionalInfo(
  props: ModalContentSchoolFeedbackAdditionalInfoProps,
) {
  const { error, onAdditionalInfoSubmit, onDismiss, title } = props;
  const [additionalInfo, setAdditionalInfo] = useState<string>("");

  return (
    <ModalSubProfileEdit>
      <ModalSubProfileEditHeader onDismiss={onDismiss} title={title} />
      <ModalSubProfileEditBody>
        {!!error && <AlertError />}
        {/* TODO: See if we can replace this w/ <TextAreaInput/> in swing-components */}
        <TextAreaInput
          onChange={(info: string) => setAdditionalInfo(info)}
          value={additionalInfo}
          label={translate("SCHOOL_FEEDBACK_ADDITIONAL_INFO_LABEL")}
          placeholder={translate("SCHOOL_FEEDBACK_ADDITIONAL_INFO_PLACEHOLDER")}
        />
      </ModalSubProfileEditBody>
      <ModalSubProfileEditFooter
        buttonPrimary={{
          isDisabled: false,
          text: translate("SCHOOL_FEEDBACK_ADDITIONAL_INFO_SUBMIT_BUTTON_LABEL"),
          onClick: () => {
            onAdditionalInfoSubmit(additionalInfo.trim());
          },
        }}
      />
    </ModalSubProfileEdit>
  );
}
